import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "midTitle text-center" }
const _hoisted_2 = { class: "text-center mt-5" }
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_item = _resolveComponent("form-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        localizedKey: "Inserisci i seguenti dati per procedere",
        text: "Inserisci i seguenti dati per procedere"
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offer.formItems, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.name
      }, [
        _createVNode(_component_form_item, {
          class: "mt-3",
          config: item,
          modelValue: _ctx.cart.formAnswers[item.name],
          "onUpdate:modelValue": ($event: any) => ((_ctx.cart.formAnswers[item.name]) = $event)
        }, null, 8, ["config", "modelValue", "onUpdate:modelValue"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prev'))),
        class: "btn btn-primary me-1"
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Indietro",
          text: "Indietro"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next'))),
        class: "btn btn-primary ms-1",
        disabled: !_ctx.isFormOk
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Avanti",
          text: "Avanti"
        })
      ], 8, _hoisted_3)
    ])
  ]))
}